<template>
  <section class="content">
    <v-container container--fluid grid-list-md>
      <v-layout row justify-center wrap>
        <!-- Post Preview -->
        <v-flex v-if="post" md6 xs12>
          <v-card>
            <v-card-title primary-title>
              <div v-if="influencerData">
                <!-- <v-avatar size="35" color="grey lighten-4">
                  <img
                    class="elevation-6"
                    v-bind:src="influencerData.profilePicture"
                    alt="avatar"
                  >
                </v-avatar> -->
                <a
                  :href="influencerProfileURL"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <v-icon
                    v-if="influencerData.platform === 'linkedin'"
                    color="#0A66C2"
                    small
                  >mdi-linkedin</v-icon>
                  &nbsp; @{{influencerData.username}}
                </a>
              </div>
              <v-spacer></v-spacer>
              <div class="font-weight-bold">{{post.campaignName}} Campaign</div>
            </v-card-title>
              <v-container grid-list-sm container--fluid>
                <v-alert
                  :value="post.images.length === 0"
                  color="info" icon="info"
                  outlined
                >
                  No Media found for this post.
                </v-alert>
                <v-layout row wrap justify-center justify-space-around>
                  <v-flex v-for="(img,i) in post.images" :key="i" md4 xs12>
                    <v-card text tile v-if="!img.isvideo">
                      <a :href="img.url" download target="_blank">
                        <v-img :src="img.url" contain max-height="300"></v-img>
                      </a>
                      <!-- <div v-if="img.isvideo" class="elevation-8">
                        <video id="previewVideo" width="100%" controls>
                          <source :src="img.url" type="video/mp4">
                          Your browser does not support the video tag.
                        </video>
                      </div> -->
                    </v-card>
                    <v-card text tile v-if="img.publicID && img.isvideo">
                      <custom-media-v2
                        :media="campaignHelper.customPostMediaConfig(img, { videoDownload: true })"
                      />
                    </v-card>
                    <v-card text tile v-else>
                      <div v-if="img.isvideo" class="elevation-8">
                        <video id="previewVideo" width="100%" controls>
                          <source :src="img.url" type="video/mp4">
                          Your browser does not support the video tag.
                        </video>
                      </div>
                    </v-card>
                    <btn-download :url="img.url" v-if="img.type === 'video/quicktime'"></btn-download>
                  </v-flex>
                </v-layout>
              </v-container>
            <v-card-text>
              <p class="body-1">
                <v-textarea
                  readonly filled
                  auto-grow
                  label="Caption"
                  :value="post.captionText">
                </v-textarea>
              </p>
              <div class="body-1">
                <v-textarea
                  readonly
                  filled
                  auto-grow
                  rows="4"
                  label="Kobe Remark"
                  v-model="post.remark"
                  counter
                  >
                </v-textarea>
              </div>
              <div v-if="isVideoLink">
                <div v-if="post.vdoLink" class="caption-text">
                  <v-text-field
                    readonly filled
                    auto-grow
                    label="Link"
                    :value="post.vdoLink">
                  </v-text-field>
                </div>
              </div>
              <v-layout row wrap justify-center v-if="post.postDate">
                <div xs12 md6>
                  <v-chip label class="subtitle-1">
                    <span>Scheduled Date: </span>
                    <strong>{{post.postDate}}</strong>
                  </v-chip>
                </div>
              </v-layout>
              <!-- Comments Client <=> Client -->
              <v-flex>
                <v-expansion-panels>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      <div class="subtitle-2">
                        <v-icon color="primary">message</v-icon>
                        Internal Notes (for your internal communication only, neither Kobe nor the creators would have access to these notes)
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-container>
                        <chat-box
                          label=""
                          :messages="clientMessages"
                          @commented="sendClientMessage"
                          type="internal_notes"
                          :isClient="true"
                        />
                      </v-container>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-flex>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex md6 xs12 v-if="!loading">
          <v-layout align-space-between column>
            <v-flex>
            <!-- Start Question -->
              <v-card class="elevation-8" v-show="showStartQuestion">
                <v-card-text v-if="post.remark">
                  <!-- Kobe Remarks -->
                  <div class="body-1">
                    <v-textarea
                      readonly
                      filled
                      auto-grow
                      rows="4"
                      label="Kobe Remark"
                      v-model="post.remark"
                      counter
                      >
                    </v-textarea>
                  </div>
                </v-card-text>
                <v-card-text>
                  <v-alert color="info" icon="info" outlined>{{notes.beforeStart}}</v-alert>
                </v-card-text>
                <v-card-text>
                  <p class="text-center subtitle-1 font-weight-bold">Is the Draft Approved?</p>
                </v-card-text>
                <v-card-actions>
                  <v-btn
                    block dark
                    color="green"
                    @click="reviewSection = true, showStartQuestion = false"
                  >YES, APPROVE AND SCHEDULE</v-btn>
                </v-card-actions>
                <v-card-actions>
                  <v-btn
                    small dark
                    block text
                    color="red"
                    @click="reportSection = true, showStartQuestion = false"
                  >NO, REPORT ABUSE</v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>
            <!-- Post Review Summary -->
            <v-flex v-if="clientReportAbuse.length > 0">
              <v-card class="elevation-8" v-show="showReviewSummary">
                <v-card-title class="title">Post Review History</v-card-title>
                <v-card-text>
                  <v-expansion-panels>
                    <v-expansion-panel
                      v-for="(item, i) in clientReportAbuse"
                      :key="i"
                    >
                      <v-expansion-panel-header>
                        Review {{i+1}}
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-card>
                          <v-card-text class="grey lighten-3">
                            <h4>Reasons for Non-Approval</h4>
                            <p>
                              <ol>
                                <li v-for="r in item.reasons" :key="r">{{r}}</li>
                              </ol>
                            </p>
                            <h4>Comments for Non-Approval:</h4>
                            <p>
                              {{item.comment}}
                            </p>
                            <div v-if="item.files">
                              <h4>Uploaded Screenshots:</h4>
                              <p>
                                <ol>
                                  <li v-for="(f, index) in item.files" :key="index">
                                    <a :href="f.url" target="_blank">{{utilsFunc.getFileNameFromURL(f.url)}}</a>
                                  </li>
                                </ol>
                              </p>
                            </div>
                          </v-card-text>
                        </v-card>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
          <!-- Review Section -->
          <v-card v-if="reviewSection">
            <v-form>
              <v-card-text transition="fade-transition">
                <div class="text-center title">
                  <v-icon color="secondary" size="75">rate_review</v-icon>
                  <p>Rate & Review</p>
                </div>
                <v-container>
                  <v-flex xs12>
                    <p class="subtitle-1">Kindly Rate Influencer's Quality of Work</p>
                    <v-rating
                      v-model="submissionReview.approveRatings"
                      color="secondary"
                      size="45"
                    ></v-rating>
                    <v-divider></v-divider>
                  </v-flex>
                  <v-flex xs12>
                    <v-expand-transition>
                      <div
                        v-show="submissionReview.approveRatings > 0 && submissionReview.approveRatings <= 4"
                      >
                        <p class="subtitle-1">
                          <v-textarea
                            filled
                            label="How can we make this a 5 stars?"
                            v-model="submissionReview.approveSuggestion"
                          ></v-textarea>
                        </p>
                        <v-divider></v-divider>
                      </div>
                    </v-expand-transition>
                    <v-expand-transition>
                      <div
                        v-show="submissionReview.approveRatings > 0 && submissionReview.approveRatings == 5"
                      >
                        <p class="subtitle-1">
                          <v-textarea
                            filled
                            label="Leave Influencer a compliment?"
                            v-model="submissionReview.approveCompliment"
                          ></v-textarea>
                        </p>
                        <v-divider></v-divider>
                      </div>
                    </v-expand-transition>
                  </v-flex>
                  <v-flex xs12 v-if="post.postDate">
                    <div v-show="!post.propose_dates && askDate">
                      <p class="subtitle-1">
                        Tentatively To go Live on
                        <span class="font-weight-bold">{{post.postDate}}</span> ?
                        <br>
                        <v-btn text small color="red" @click="changeDate = true">No, Change Date</v-btn>
                        <v-btn text small color="green" @click="askDate = false">Yes, Date is Okay</v-btn>
                      </p>
                    </div>
                    <p class="subtitle-1" v-if="!askDate">
                      Requested Date:
                      <span
                        class="font-weight-bold"
                      >{{submissionReview.wantedLiveDate ? submissionReview.wantedLiveDate : post.postDate}}</span>
                      <v-icon @click="changeDate = true">edit</v-icon>
                    </p>
                    <v-divider></v-divider>
                  </v-flex>
                </v-container>
                <v-dialog
                  ref="dateDialog"
                  v-model="changeDate"
                  :return-value.sync="submissionReview.wantedLiveDate"
                  persistent
                  width="290px"
                >
                  <v-date-picker v-model="submissionReview.wantedLiveDate" scrollable :min="post.postDate" :allowed-dates="allowedDates">
                    <div class="d-flex flex-column">
                      <v-alert
                        dense
                        type="info"
                        style="margin-top:-20px"
                      >
                        Tentative live date indicated is assuming the earliest available date
                      </v-alert>
                      <div class="text-right">
                        <v-btn text color="secondary" @click="changeDate = false">Cancel</v-btn>
                        <v-btn
                          text
                          color="secondary"
                          @click="saveWantedLiveDate"
                          @click.stop="askDate = false"
                        >OK</v-btn>
                      </div>
                    </div>
                  </v-date-picker>
                </v-dialog>
              </v-card-text>
              <v-card-actions>
                <v-btn dark block color="warning" @click="submitApprove()" v-if="showChangeRequest">Request Date Change</v-btn>
                <v-btn dark block color="green" @click="submitApprove()" v-if="showApprove">Approve</v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
          <!-- Report Abuse Section -->
          <v-card v-if="reportSection">
            <v-form>
              <v-card-text>
                <div class="text-center title">
                  <v-icon color="deep-orange" size="75">report_problem</v-icon>
                  <p>Report an Abuse</p>
                </div>
                <v-container container--fluid>
                  <p class="subtitle-1">1. Please select reasons for Non Approval</p>
                  <v-checkbox
                    v-for="(item, i) in abuseReasons"
                    :key="i"
                    v-model="submissionReview.abuseReasons"
                    :label="item"
                    :value="item"
                    height="5"
                  ></v-checkbox>
                </v-container>
                <v-container>
                  <p class="subtitle-1">2. Comments for Abuse</p>
                  <v-textarea filled auto-grow v-model="submissionReview.abuseComment"></v-textarea>
                </v-container>
                <v-container>
                  <p class="subtitle-1">3. Upload Screenshots</p>
                  <custom-file-upload
                    :refresh="fileUploadRefresh"
                    :multiple="true"
                    @setMedias="updateFiles"
                  />
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-btn dark block color="deep-orange" @click="submitAbuse()">Submit Abuse</v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
          <v-btn v-if="!showStartQuestion" block @click="reset()" text>
            <v-icon>arrow_back_ios</v-icon>Go Back
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>

<script>
import postConfig from './postConfig';
import postAPIs from './postApi';
import utils from '@/utils'
import btnDownload from '@/components/scoped/custom/BtnDownload.vue';
import CustomMediaV2 from '../../scoped/custom/CustomMediaV2';
import CustomFileUpload from '../../scoped/custom/CustomFileUpload';
import campaignHelper from '../Campaign/campaignHelper';
import moment from 'moment'
import chatBox from './PostChatBox';
export default {
  data() {
    return {
      post: null,
      clientReportAbuse: [],
      influencerData: null,
      influencerIG: null,
      loading: false,
      showStartQuestion: true,
      showReviewSummary: true,
      reviewSection: false,
      reportSection: false,
      changeDate: false,
      askDate: true,
      showChangeRequest: false,
      showApprove: true,
      submissionReview: {
        abuseReasons: [],
        abuseComment: null,
        approveRatings: null,
        approveSuggestion: null,
        approveCompliment: null,
        wantedLiveDate: null,
        influencerID: null,
        postID: null,
        abuseSubmitted: false
      },
      campaignHelper,
      files: [],
      fileUploadRefresh: 0,
      utilsFunc: utils.func,
      clientMessages: []
    };
  },
  components: {
    btnDownload,
    CustomFileUpload,
    CustomMediaV2,
    chatBox
  },
  computed: {
    notes: () => postConfig.submissionReviewNotes,
    abuseReasons: () => postConfig.nonApprovalReasons,
    user: function() {
      return this.$store.state.user;
    },
    influencerProfileURL() {
      if (!this.influencerData) return '#'
      const username = String(this.influencerData.username || '').replace(/^@/, '')
      if (this.influencerData.platform === 'linkedin') {
        return `https://www.linkedin.com/in/${username}`
      }
      if (this.influencerData.platform === 'tiktok') {
        return `https://www.tiktok.com/@${username}`
      }
      if (this.influencerData.platform === 'youtube') {
        return `https://youtube.com/@${username}`
      }
      if (this.influencerData.platform === 'facebook') {
        return `https://facebook.com/${username}`
      }
      return `https://instagram.com/${username}`
    },
    isVideoLink() {
      return this.post.type === 'story' ||
      this.post.type === 'video' ||
      this.post.type === 'reel' ||
      this.post.type === 'tiktok' ||
      this.post.type === 'youtube' ||
      this.post.type === 'facebook' ||
      this.post.type === 'linkedin'
    }
  },
  created() {
    this.getPost(this.$route.query.id)
    this.$swal({
      title: 'Terms and Agreements',
      html: `<p class="text-xs-left subtitle-1">Please note that the content creator reserves full creative rights to the final execution of the post and will only do 1 shoot based on the brief approved by the client. Drafts sent to clients for vetting are for the sole purpose of fact-checking and stylistic changes will not be allowed. The client is entitled to only 1 revision. </p>`,
      type: 'info',
      width: 500,
      backdrop: `rgba(0,0,1, 0.7)`,
      showCancelButton: true,
      confirmButtonText: 'Agree',
      cancelButtonText: 'Disagree',
      allowOutsideClick: false
    }).then((result) => {
      if (!result.value) {
        this.$router.push({path: '/clients/posts'})
      }
    })
  },
  methods: {
    submitAbuse() {
      if (this.submissionReview.abuseReasons.length === 0) {
        this.$swal({
          title: 'Please select at least one reason.',
          type: 'warning'
        })
      } else if (this.submissionReview.abuseComment === null) {
        this.$swal({
          title: 'Comments is required',
          type: 'warning'
        })
      } else {
        this.submissionReview.abuseSubmitted = true;
        this.$swal({
          title: 'Do you want to report this post?',
          type: 'question',
          confirmButtonText: 'Yes, Report',
          cancelButtonText: 'Cancel',
          showCancelButton: true,
          showCloseButton: true
        }).then(result => {
          if (result.value) {
            let body = {
              comment: this.submissionReview.abuseComment,
              reasons: this.submissionReview.abuseReasons
            };
            let formData = new FormData();
            formData.append('data', JSON.stringify(body))
            for (let val of this.files) {
              formData.append('uploadFile', val)
            }
            postAPIs
              .clientReportPost(this.post._id, formData)
              .then(() => {
                this.$swal({
                  type: 'success',
                  title: 'Reported'
                }).then(() => this.$router.push({path: '/clients/posts'}));
              })
              .catch(() =>
                this.$swal({
                  type: 'error',
                  title: 'Some thing went wrong'
                })
              );
          }
        });
      }
    },
    submitApprove() {
      if (this.submissionReview.approveRatings === null) {
        this.$swal({
          title: 'Rating is required',
          type: 'warning'
        })
      } else if (this.submissionReview.approveSuggestion === null &&
        this.submissionReview.approveCompliment === null) {
        this.$swal({
          title: 'Your comment is required',
          type: 'warning'
        })
      } else {
        let msgTitle = ''
        let confirmBtnText = ''
        if (this.showApprove) {
          msgTitle = 'Do you want to approve this post?'
          confirmBtnText = 'Yes, Approve'
        }
        if (this.showChangeRequest) {
          msgTitle = 'Do you want to request date change this post?'
          confirmBtnText = 'Yes, Request Change'
        }
        this.$swal({
          title: msgTitle,
          type: 'question',
          confirmButtonText: confirmBtnText,
          cancelButtonText: 'Cancel',
          showCancelButton: true,
          showCloseButton: true
        }).then(result => {
          if (result.value) {
            let body = {
              rating: this.submissionReview.approveRatings,
              comment: this.submissionReview.approveSuggestion || this.submissionReview.approveCompliment,
              appLink: window.location.protocol + '//' + window.location.host + '/posts/internal/approved?campaignID=' + this.post.campaignID + '&postID=' + this.post._id + '&confirmDate=true',
              isRequestDateChange: this.showChangeRequest
            };
            if (this.showApprove) {
              body.postDate = this.submissionReview.wantedLiveDate || this.post.postDate
              if (body.postDate < utils.func.formatCustomDate(moment(), 'YYYY-MM-DD')) {
                body.isDateOverdue = true
              }
              body.isApprove = true
            }
            if (this.showChangeRequest) {
              body.postDate = this.submissionReview.wantedLiveDate || this.post.postDate
            }
            postAPIs
              .clientApprovePost([
                {
                  id: this.post._id,
                  body
                }
              ])
              .then(async () => {
                let successTitle = ''
                if (this.showChangeRequest) {
                  successTitle = 'Your date change request has been captured, date is subjected to availability. The team will be in touch for next steps.'
                } else if (this.showApprove) {
                  successTitle = 'Approved'
                }
                this.$swal({
                  type: 'success',
                  title: successTitle
                }).then(async () => {
                  this.$router.push({path: '/clients/posts'})
                });
              })
              .catch(() =>
                this.$swal({
                  type: 'error',
                  title: 'Some thing went wrong'
                })
              );
          }
        });
      }
    },
    getPost(postId) {
      this.loading = true
      postAPIs
        .getPostById(postId)
        .then(response => {
          this.post = response.mainPost
          this.influencerData = response.influencer
          this.clientReportAbuse = response.reportAbuse
          this.clientMessages = response.clientComments || []
          this.loading = false
        })
        .catch(err => {
          this.$swal({
            title: `Can't Load the Post`,
            type: 'error',
            text: err
          }).then(() => this.$router.push({path: '/clients/posts'}))
        }
        );
    },
    reset() {
      this.showStartQuestion = true;
      this.reviewSection = false;
      this.reportSection = false;
      this.changeDate = false;
      this.askDate = true;
      this.submissionReview = {
        abuseReasons: [],
        abuseComment: null,
        approveRatings: null,
        approveSuggestion: null,
        approveCompliment: null,
        wantedLiveDate: null,
        abuseSubmitted: false
      };
    },
    saveWantedLiveDate() {
      this.$refs.dateDialog.save(this.submissionReview.wantedLiveDate)
      this.showApprove = false
      if (!this.post.propose_dates) {
        this.showChangeRequest = true
      } else {
        this.showApprove = true
      }
    },
    allowedDates(val) {
      if (this.post.propose_dates && this.post.propose_dates.length > 0) {
        return this.post.propose_dates.includes(val)
      }
      if (!this.post.propose_dates) return true
      return false
    },
    updateFiles(medias) {
      this.files = Object.assign([], medias)
    },
    sendClientMessage: function(message) {
      if (!message) {
        this.$swal(`Comment can't be empty`)
      } else {
        postAPIs.clientComment(this.post._id, message)
          .then((comment) => {
            this.post.client_comments ? '' : this.post.client_comments = []
            this.post.client_comments.push(
              {
                comment: message,
                commentator: this.user.firstName,
                createdAt: moment()
              }
            )
            this.clientMessages.push(comment)
          })
        .catch(error => {
          this.$swal({
            title: `Can't Make Comments now, try again later`,
            type: 'error',
            content: error
          });
        });
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// SubmissionReview.vue?38414286